export const BUTTON = 'BUTTON'
export const HEADER = 'Header'
export const NOIMAGE = 'Add image in the edit box to the right.'
export const NOITEMS = 'No items added yet. Please use the right edit bar to add elements'
export const RTE = '<p class="no-items">Start writing here.</p>'



// WEBPACK FOOTER //
// ./state/types/defaultLabel.js